import type { FC } from 'react';
import React from 'react';
import classes from './MapLayerManager.module.css';

type Props = {
  children?: React.ReactNode;
};

export const MapLayerManager: FC<Props> = (props) => {
  const children = React.Children.toArray(props.children);
  return (
    <div className={classes.wrapper} data-testid="map-layer-manager">
      {children
        .filter((c) => c)
        .map((control, idx) => (
          <div
            id={`map-layer-manager-${idx}`}
            key={`map-layer-manager-${idx}`}
            className={classes.layerControl}
            data-testid="map-layer-manager-item"
          >
            <div id={`map-layer-manager-item-${idx}`}>{control}</div>
          </div>
        ))}
    </div>
  );
};
